import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from '../../services/user.service';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { EmailSettingsV2Service } from '~services/email-settings-v2.service';

@Component({
  selector: 'sa-email-details-v2',
  templateUrl: './email-details-v2.component.html',
  styleUrls: ['./email-details-v2.component.scss'],
})
export class EmailDetailsV2Component implements OnInit {
  displayNav = false;
  userLabel: { name: string; email: string; account: string };
  activeDataSource: MatTableDataSource<any>;
  displayedColumns = ['sender', 'uploadTime', 'files'];
  emails = [];
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private emailSettingsV2Service: EmailSettingsV2Service,
  ) {}

  ngOnInit() {
    this.userLabel = this.userService.getLabel();
    const emailId = parseInt(this.route.snapshot.params['id'], 10);
    this.emailSettingsV2Service
      .getEmailsDetailsById(emailId)
      .pipe(map((settings) => settings.sort(this.compareFn).reverse()))
      .subscribe((emailSettings) => {
        this.activeDataSource = new MatTableDataSource(emailSettings);
        this.activeDataSource.sort = this.sort;
      });
  }

  private compareFn = (a, b) => {
    if (new Date(a.uploadTime) < new Date(b.uploadTime)) {
      return -1;
    }
    if (new Date(a.uploadTime) > new Date(b.uploadTime)) {
      return 1;
    }
    return 0;
  };

  downloadFile(fileName: string) {
    this.emailSettingsV2Service.downloadFile(fileName).subscribe((_) => {
      window.open(_, '_blank');
    });
  }

  menuClick() {
    this.displayNav = !this.displayNav;
  }
}
